import { Select } from 'antd';

import { FormItemField } from '../../FormItemField';

import type { DefaultOptionType } from 'antd/es/select';

type SelectFieldProps = {
  label: string;
  fieldName: string | number | (string | number)[];
  placeholder: string;
  options: DefaultOptionType[];
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
  validateStatus?: 'success' | 'warning' | 'error' | 'validating';
};

export const SelectField = ({
  label,
  fieldName,
  placeholder,
  options,
  disabled = false,
  size = 'middle',
  required,
  validateStatus,
}: SelectFieldProps) => (
  <FormItemField
    label={label}
    fieldName={fieldName}
    required={required}
    validateStatus={validateStatus}
  >
    <Select
      placeholder={placeholder}
      options={options}
      disabled={disabled}
      size={size}
    />
  </FormItemField>
);
